import React, { Component, Context } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter, RouteComponentProps } from "react-router-dom";
import clsx from "clsx";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import WarningIcon from "@material-ui/icons/Warning";
import IconButton from "@material-ui/core/IconButton";
import { Widget, WidgetProps } from "../widgets";
import { IStreamState, mapStreamStateToProps } from "../../redux/reducers/stream";
import { IStreamActionDispatches, mapStreamDispatchToProps } from "../../redux/actions/stream";
import { connectCustom, ICustomStoreConnectedProps } from "../../redux/actions";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { IStream } from "../../models/stream";
import { UIStyledTooltip } from "../ui/UIComponents";
import UserRoleContent from "../auth/permissions/UserRoleContent";
import { IUserAuthPayload } from "../../laco-common/base/models/user";
import FormWidget from "../siteForms/FormWidget";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import { IMembershipDetails, getMembershipDetails, BWMembershipStatus } from "../../models/bwMembership";
import { getDateDisplay } from "../../utils/date-utils";
import { UIWarningMsg } from "../notifications/component";

type StreamPageState = {
	// stream: IStream;
};

type StreamPageProps = ICustomStoreConnectedProps & WidgetProps;

class StreamPage extends Component<StreamPageProps & RouteComponentProps & IAuthProps, StreamPageState> {
	private _historySub = null;
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		// stream: null,
	};

	// TODO: optimize load
	// handle not found
	// title - move to header
	componentDidMount() {
		this._historySub = this.props.history.listen((location, action) => {
			this.init();
		});
		this.init();
	}

	componentWillUnmount() {
		this._historySub();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.authContext.isAuthenticated !== prevProps.authContext.isAuthenticated) {
			this.init();
		}
	}

	init() {
		if (this.props.authContext.isAuthenticated)
			this.props.subscriptionStoreDispatch
				.loadSubscription(this.props.authContext)
				.then((membershipDetails: IMembershipDetails) => {
					if (membershipDetails.status === BWMembershipStatus.ACTIVE)
						this.props.streamStoreDispatch.loadStreams(); // TODO: optimize
				});
	}

	render() {
		const id: any = this.props.match.params ? this.props.match.params["id"] : undefined;
		if (!id) return null;
		const stream = this.props.streamStore.streams.find((s: IStream) => s.id === id);
		if (!stream) return null;
		const membershipDetails: IMembershipDetails = this.props.subscriptionStore.membershipDetails;
		const validSubscription: boolean = membershipDetails && membershipDetails.status === BWMembershipStatus.ACTIVE;
		const darkBg: boolean = validSubscription;

		return (
			<div className="w-100 position-relative">
				<div
					className={clsx(
						!this.props.isNested && "container-fluid1",
						"container-fluid section-padding",
						darkBg && "bg-app-black",
						!darkBg && "bg-gray1"
					)}
					style={{ marginTop: "-30px" }}
				>
					<div className="container">
						<UIStyledTooltip title="Back to Streams">
							<NavLink
								to={`/${this.props.page?.path}`}
								className={clsx("d-inline-block", !darkBg && "m-2 mb-3 ml-1", darkBg && "mb-2")}
							>
								<IconButton edge="start" aria-label="Back to forms" className="icon-btn-outlined">
									<ArrowBackIcon style={darkBg ? { color: "#ffffff" } : {}} />
								</IconButton>
							</NavLink>
						</UIStyledTooltip>

						<h2 className={clsx("highlighted1 ", darkBg && "text-white")} style={{ fontSize: "1.2rem" }}>
							{stream.title}
						</h2>
					</div>

					{!!membershipDetails && (
						<UserRoleContent
							// profilePropRequired="isBW_member"
							authMessageSuffix="stream"
							className="container mt-3 mb-3"
							skipAuth={validSubscription}
							renderCustomRejectContent={(userPayload: IUserAuthPayload) => (
								<Widget
									widget={{
										id: "",
										widgetType: "digital-access",
										widgetProps: { ignoreSubscriptionStatus: true },
									}}
									page={null}
								/>
							)}
						>
							{validSubscription && (
								<iframe
									style={{ width: "100%", height: "80vh", minHeight: "600px" }}
									// src="https://online.fliphtml5.com/akxgy/wxfe/"
									src={`${stream.streamUrl}?embed`} // embed for canva
									seamless={true}
									scrolling="no"
									frameBorder={0}
									allowTransparency={true}
									allowFullScreen={true}
									/*
 									// @ts-ignore */
									loading="lazy"
								></iframe>
							)}
							{!validSubscription && (
								<div className="container">
									{membershipDetails.status === BWMembershipStatus.EXPIRED && (
										<div className="mt-1 mb-1 d-inline-flex align-items-center">
											{/* <WarningIcon className="text-warning mr-2" fontSize="small" />
											Membership Expired
											{!!membershipDetails.validThrough &&
												` on ${getDateDisplay(membershipDetails.validThrough, null)}`} */}
											<UIWarningMsg
												hideClose={true}
												className="w-auto pr-3"
												message={`Membership expired ${
													!!membershipDetails.validThrough &&
													`on ${getDateDisplay(membershipDetails.validThrough, null)}`
												}`}
											/>
										</div>
									)}
									{!membershipDetails.isSubscriber && (
										<>
											<p className="py-2">
												{this.props.page?.texts["membership-required-firewire-user"]}
											</p>
											<FormWidget
												formId="firewireRequestBWMembership"
												standalone={true}
												isNested={true}
											/>
										</>
									)}
									{membershipDetails.isSubscriber && (
										<>
											<p className="py-2">
												{this.props.page?.texts["membership-required-subscriber"]}
											</p>
											<NavLink to="/checkout#!/~/cart">
												<button className="btn btn-primary mt-1">
													{this.props.page?.texts["membership-subscriber-purchase-link"]}
												</button>
											</NavLink>
										</>
									)}
								</div>
							)}
						</UserRoleContent>
					)}
				</div>
			</div>
		);
	}
}

export default withAuth(connectCustom<StreamPageProps>(StreamPage, ["streamStore", "subscriptionStore"], true));
